module.exports = __webpack_public_path__ + "img/tenaga-kerja.b71900ea.jpeg";